// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M14p","label":"styles_label__3_4H_"};